// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1a007b3b","239":"61025db2","453":"65a1dc35","557":"92084376","648":"e0e6956d","667":"24b50d52"}[chunkId] + ".chunk.js";
};